import { and, isControl, rankWith, scopeEndsWith } from '@jsonforms/core';

const imageUploadControlTester = rankWith(
  3,
  and(isControl, scopeEndsWith('logo'))
);

export default imageUploadControlTester;
